import(/* webpackMode: "eager", webpackExports: ["ItemCard"] */ "/Users/craigshewry/madethis/sima/src/components/ItemCard.tsx");
